import { config } from "@/config";

/**
 * A permalink to the Sentry trace behind an event, or null when there is none
 * to link to.
 *
 * Two things have to be true, and neither is guaranteed. Traces are sampled, so
 * most rows carry no id at all; and the DSN does not contain the organisation
 * slug, so the deployment has to supply it. Returning null in either case is
 * the point — Sentry is where the code context lives, this is only a door to
 * it, and a door onto an empty room is worse than no door.
 */
export function getSentryTraceUrl(traceId: string | null): string | null {
  if (!traceId || !config.sentryOrgSlug) return null;
  return `https://${config.sentryOrgSlug}.sentry.io/explore/traces/trace/${traceId}/`;
}
